export default "__VITE_ASSET__315b26f2__"